import { createSelector } from 'reselect';
import property from 'lodash/property';

import getLogisticsState from './getLogisticsState';

export default createSelector(
  getLogisticsState,
  property('experiencesByShippingConfiguration'),
);
